<template>
    <div v-if="showVerticalMenu" id="vMenu">
        <div class="list-group list-group-flush panel">
            <b-list-group-item
                :href="menuRoutes['home']"
                :active="pageName === 'home'"
                class="item"
                @click="setPageName('home')"
            >
                HOME
            </b-list-group-item>
            <a
                v-b-toggle.general
                href="#"
                class="list-group-item item"
                :class="activeGeneral"
            >
                DETAILS CLIENT&nbsp;<i class="fa fa-caret-down"/>
            </a>
            <b-collapse id="general" :visible="openGeneral">
                <b-list-group-item
                    :href="menuRoutes['internal']"
                    class="item sub-item"
                    :active="pageName === 'internal'"
                    @click="setPageName('internal')"
                >
                    <i class="fa-fw fal fa-info-square menu-sub-icon"/>Infos
                    internes
                </b-list-group-item>

                <b-list-group-item
                    :href="menuRoutes['contacts']"
                    class="item sub-item"
                    :active="pageName === 'contacts'"
                    @click="setPageName('contacts')"
                >
                    <i class="fa-fw fal fa-address-card menu-sub-icon"/>
                    Contacts
                </b-list-group-item>
                <b-list-group-item
                    :href="menuRoutes['legal']"
                    class="item sub-item"
                    :active="pageName === 'legal'"
                    @click="setPageName('legal')"
                >
                    <i class="fa-fw fal fa-balance-scale menu-sub-icon"/>
                    Juridique
                </b-list-group-item>

                <b-list-group-item
                    :href="menuRoutes['taxation']"
                    class="item sub-item"
                    :active="pageName === 'taxation'"
                    @click="setPageName('taxation')"
                >
                    <i class="fa-fw fal fa-cash-register menu-sub-icon"/>
                    Fiscalité
                </b-list-group-item>

                <b-list-group-item
                    v-if="company.legal_form !== 'PP'"
                    :href="menuRoutes['chiefs']"
                    class="item sub-item"
                    :active="pageName === 'chiefs'"
                    @click="setPageName('chiefs')"
                >
                    <i
                        class="fa-fw fal fa-user-crown menu-sub-icon"
                    />DIRIGEANTS & CACs
                </b-list-group-item>

                <b-list-group-item
                    v-if="company.legal_form !== 'PP' && false"
                    :href="menuRoutes['associates']"
                    class="item sub-item"
                    :active="pageName === 'associates'"
                    @click="setPageName('associates')"
                >
                    <i class="fa-fw fal fa-user-friends menu-sub-icon"/>
                    Capital et associés
                </b-list-group-item>

                <b-list-group-item
                    v-if="menuRoutes['dashboardsMenu']"
                    :href="menuRoutes['fees']"
                    class="item sub-item"
                    :active="pageName === 'client-fees'"
                    @click="setPageName('client-fees')"
                >
                    <i class="fa-fw fal fa-euro-sign menu-sub-icon"/>Honoraires
                </b-list-group-item>

                <b-list-group-item
                    v-if="company.legal_form !== 'PP'"
                    :href="menuRoutes['pappers']"
                    class="item sub-item"
                    :active="pageName === 'pappers'"
                    @click="setPageName('pappers')"
                >
                    <i class="fa-fw fal fa-database menu-sub-icon"/>Données
                    Pappers
                </b-list-group-item>

                <b-list-group-item
                    v-if="true"
                    :href="menuRoutes['invoicing.bank']"
                    class="item sub-item"
                    :active="pageName === 'invoicingBank'"
                    @click="setPageName('invoicingBank')"
                >
                    <i class="fa-fw fal fa-university menu-sub-icon"/>
                    Banques et modes de paiement
                </b-list-group-item>
            </b-collapse>
        </div>

        <div v-if="quotationMenu" class="list-group list-group-flush panel">
            <a
                v-b-toggle.quotation
                href="#"
                class="list-group-item item"
                :class="activeQuotation"
            >
                DEVIS ET LETTRE DE MISSION&nbsp;<i class="fa fa-caret-down"/>
            </a>
            <b-collapse id="quotation" :visible="openQuotation">

                <b-list-group-item
                    :href="menuRoutes['quotation.calculator']"
                    class="item sub-item"
                    :active="pageName === 'quotationCalculator'"
                    @click="setPageName('quotationCalculator')"
                >
                    <i class="fa-fw fal fa-calculator menu-sub-icon"/>
                    Générateur de devis
                </b-list-group-item>
                <b-list-group-item
                    :href="menuRoutes['quotation.documents']"
                    class="item sub-item"
                    :active="pageName === 'quotationDocuments'"
                    @click="setPageName('quotationDocuments')"
                >
                    <i class="fa-fw fal fa-folders menu-sub-icon"/>
                    Liste des devis
                </b-list-group-item>
                <b-list-group-item
                    :href="menuRoutes['quotation.letters']"
                    class="item sub-item"
                    :active="pageName === 'missionLetters'"
                    @click="setPageName('missionLetters')"
                >
                    <i class="fa-fw fal fa-typewriter menu-sub-icon"/>
                    Lettres de mission
                </b-list-group-item>
            </b-collapse>
        </div>
        <div class="list-group list-group-flush panel">
            <a
                v-b-toggle.activity
                href="#"
                class="list-group-item item"
                :class="activeActivity"
            >
                GESTION ECHEANCES&nbsp;<i class="fa fa-caret-down"/>
            </a>
            <b-collapse id="activity" :visible="openActivity">
                <b-list-group-item
                    :href="menuRoutes['roles']"
                    class="item sub-item"
                    :active="pageName === 'roles'"
                    @click="setPageName('roles')"
                >
                    <i class="fa-fw fal fa-user-tag menu-sub-icon"/>Rôles
                </b-list-group-item>
                <b-list-group-item
                    :href="menuRoutes['missions']"
                    class="item sub-item"
                    :active="pageName === 'missions'"
                    @click="setPageName('missions')"
                >
                    <i class="fa-fw fal fa-cog menu-sub-icon"/>Missions
                </b-list-group-item>
                <b-list-group-item
                    :href="menuRoutes['actions']"
                    class="item sub-item"
                    :active="pageName === 'actions'"
                    @click="setPageName('actions')"
                >
                    <i class="fa-fw fal fa-clipboard-list menu-sub-icon"/>
                    Actions
                </b-list-group-item>
                <b-list-group-item
                    :href="menuRoutes['clientDeadlines']"
                    class="item sub-item"
                    :active="pageName === 'clientDeadlines'"
                    @click="setPageName('clientDeadlines')"
                >
                    <i
                        class="fa-fw fal fa-calendar-alt menu-sub-icon"
                    />Echéances
                </b-list-group-item>
            </b-collapse>
        </div>
        <div v-if="invoicingMenu" class="list-group list-group-flush panel">
            <a
                v-b-toggle.invoicing
                href="#"
                class="list-group-item item"
                :class="activeInvoicing"
            >
                FACTURATION&nbsp;<i class="fa fa-caret-down"/>
            </a>
            <b-collapse id="invoicing" :visible="openInvoicing">
                <b-list-group-item
                    :href="menuRoutes['invoicing.documents']"
                    class="item sub-item"
                    :active="pageName === 'invoicingDocuments'"
                    @click="setPageName('invoicingDocuments')"
                >
                    <i class="fa-fw fal fa-folders menu-sub-icon"/>
                    Liste des factures et avoirs
                </b-list-group-item>
                <b-list-group-item
                    :href="menuRoutes['invoicing.rules']"
                    class="item sub-item"
                    :active="pageName === 'invoicingRules'"
                    @click="setPageName('invoicingRules')"
                >
                    <i class="fa-fw fal fa-book menu-sub-icon"/>
                    Règles de facturation
                </b-list-group-item>
                <b-list-group-item
                    :href="menuRoutes['invoicing.plan']"
                    class="item sub-item"
                    :active="pageName === 'invoicingPlan'"
                    @click="setPageName('invoicingPlan')"
                >
                    <i class="fa-fw fal fa-table menu-sub-icon"/>
                    Plan de facturation
                </b-list-group-item>
                <!--                <b-list-group-item-->
                <!--                    :href="menuRoutes['invoicing.deadlines']"-->
                <!--                    class="item sub-item"-->
                <!--                    :active="pageName === 'invoicingDeadlines'"-->
                <!--                    @click="setPageName('invoicingDeadlines')"-->
                <!--                >-->
                <!--                    <i class="fa-fw fal fa-calendar-alt menu-sub-icon" />-->
                <!--                    Echéances-->
                <!--                </b-list-group-item>-->
            </b-collapse>
        </div>
        <div class="list-group list-group-flush panel">
            <a
                v-b-toggle.taskHistory
                href="#"
                class="list-group-item item"
                :class="activeTaskHistory"
            >
                TACHES & COMMENTAIRES&nbsp;<i class="fa fa-caret-down"/>
            </a>
            <b-collapse id="taskHistory" :visible="openTaskHistory">
                <b-list-group-item
                    :href="menuRoutes['tasks.index']"
                    class="item sub-item"
                    :active="
                        pageName === 'tasks.index' ||
                        pageName === 'tasks.create' ||
                        pageName === 'tasks.edit'
                    "
                    @click="setPageName('tasks.index')"
                >
                    <i class="fa-fw fal fa-tasks menu-sub-icon"/>To do
                </b-list-group-item>
                <b-list-group-item
                    :href="menuRoutes['history.index']"
                    class="item sub-item"
                    :active="
                        pageName === 'history.index' ||
                        pageName === 'history.create' ||
                        pageName === 'history.edit'
                    "
                    @click="setPageName('history')"
                >
                    <i class="fa-fw fal fa-comment menu-sub-icon"/>
                    Commentaires
                </b-list-group-item>
            </b-collapse>
        </div>
        <!--
                <div class="list-group list-group-flush panel">
                    <a href="#" class="list-group-item item" v-b-toggle.pendingPoints :class="this.activePending">
                        POINTS EN SUSPENS&nbsp;<i class="fa fa-caret-down" />
                    </a>
                    <b-collapse id="pendingPoints" :visible="this.openPending">
                        <b-list-group-item :href="this.menuRoutes['pendingImport']"
                                           class="item sub-item"
                                           :active="this.pageName==='pendingImport'"
                                           @click="setPageName('pendingImport')">
                            <i class="fa-fw fal fa-upload menu-sub-icon" />Importation
                        </b-list-group-item>
                        <b-list-group-item :href="this.menuRoutes['pendingImported']"
                                           class="item sub-item"
                                           :active="this.pageName==='pendingImported'"
                                           @click="setPageName('pendingImported')">
                            <i class="fa-fw fal fa-ban menu-sub-icon" />Points non transmis
                            <div class="float-right">
                                <single-counter :value="this.counters.IMP" v-if="showCounters"></single-counter>
                            </div>
                        </b-list-group-item>
                        <b-list-group-item :href="this.menuRoutes['pendingSent']"
                                           class="item sub-item"
                                           :active="this.pageName==='pendingSent'"
                                           @click="setPageName('pendingSent')">
                            <i class="fa-fw fal fa-share-square menu-sub-icon" />Points transmis
                            <div class="float-right">
                                <single-counter :value="this.counters.SEN" v-if="showCounters"></single-counter>
                            </div>
                        </b-list-group-item>
                        <b-list-group-item :href="this.menuRoutes['pendingAnswered']"
                                           class="item sub-item"
                                           :active="this.pageName==='pendingAnswered'"
                                           @click="setPageName('pendingAnswered')">
                            <i class="fa-fw fal fa-square menu-sub-icon" />Points répondus
                            <div class="float-right">
                                <single-counter :value="this.counters.ANS" v-if="showCounters"></single-counter>
                            </div>
                        </b-list-group-item>
                        <b-list-group-item :href="this.menuRoutes['pendingSolved']"
                                           class="item sub-item"
                                           :active="this.pageName==='pendingSolved'"
                                           @click="setPageName('pendingSolved')">
                            <i class="fa-fw fal fa-check-square menu-sub-icon" />Points traités
                            <div class="float-right">
                                <single-counter :value="this.counters.SOL" v-if="showCounters"></single-counter>
                            </div>
                        </b-list-group-item>
                    </b-collapse>
                </div>
                -->
    </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
    name: 'ClientVerticalMenu',

    props: {
        company: {
            type: Object,
            required: true,
        },
        client: {
            type: Number,
            required: true,
        },
        page: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            openGeneral: false,
            activeGeneral: '',
            openActivity: false,
            activeActivity: '',
            openTaskHistory: false,
            activeTaskHistory: '',
            openPending: false,
            activePending: '',
            openInvoicing: false,
            activeInvoicing: '',
            openQuotation: false,
            activeQuotation: '',
        }
    },

    computed: {
        ...mapState({
            counters: (state) => state.clientVM.counters,
            showCounters: (state) => state.clientVM.showCounters,
            pageName: (state) => state.browsing.pageName,
            showVerticalMenu: (state) => state.clientVM.showVerticalMenu,
            menuRoutes: (state) => state.clientVM.menuRoutes,
        }),

        invoicingMenu() {
            return 'invoicing.documents' in this.menuRoutes
        },

        quotationMenu() {
            return 'quotation.documents' in this.menuRoutes
        },
    },

    async created() {
        this.setPageName()
        await this.$store.dispatch('clientVM/getRoutes', this.client)
        this.$store.commit('clientVM/SHOW_VERTICAL_MENU')
        this.handleGeneralMenu()
        this.handleActivityMenu()
        this.handleTaskHistorylMenu()
        this.handlePendingMenu()
        this.handleInvoicingMenu()
        this.handleQuotationMenu()
    },

    methods: {
        setPageName() {
            console.log(this.page)
            this.$store.commit('browsing/SET_PAGE_NAME', this.page)
        },

        handleGeneralMenu() {
            this.openGeneral = [
                'contacts',
                'legal',
                'internal',
                'turnover',
                'client-fees',
                'associates',
                'chiefs',
                'auditors',
                'taxation',
                'pappers',
                'invoicingBank',
            ].includes(this.page)
            this.activeGeneral = this.openGeneral ? 'active' : ''
        },

        handleActivityMenu() {
            this.openActivity = [
                'roles',
                'missions',
                'actions',
                'clientDeadlines',
            ].includes(this.page)
            this.activeActivity = this.openActivity ? 'active' : ''
        },

        handleTaskHistorylMenu() {
            this.openTaskHistory = ['history.index', 'tasks.index'].includes(
                this.page
            )
            this.activeTaskHistory = this.openTaskHistory ? 'active' : ''
        },

        handleInvoicingMenu() {
            this.openInvoicing = [
                'invoicingDocuments',
                'invoicingMandate',
                'invoicingPlan',
                'invoicingDeadlines',
                'invoicingPre',
                'invoicingRules',
            ].includes(this.page)
            this.activeInvoicing = this.openInvoicing ? 'active' : ''
        },

        handlePendingMenu() {
            this.openPending = [
                'pendingImport',
                'pendingImported',
                'pendingSent',
                'pendingAnswered',
                'pendingSolved',
            ].includes(this.page)
            this.activePending = this.openPending ? 'active' : ''
        },

        handleQuotationMenu() {
            this.openQuotation = [
                'quotationCalculator',
                'quotationLetter',
                'quotationDocuments',
            ].includes(this.page)
            this.activeQuotation = this.openQuotation ? 'active' : ''
        },
    },
}
</script>

<style scoped></style>
